import React from 'react'
import {BarChart, typeData} from 'components/UI/BarChart/BarChart'
import {useSelector} from 'react-redux'
import {typeStatisticsState} from 'model/dashboardStatistics/dStatisticsReducer'

import {Loader} from 'components/UI/Loader/Loader'
import {Alert} from 'components/UI/Alert/Alert'
import {Trans} from '@lingui/macro'



// Type
export type typeMainBar = {
    amountTitle?: string
    mainStatisticData: typeData | null
}


// Component
export const MainBar: React.FC<typeMainBar> = ({ amountTitle, mainStatisticData}) => {

    // System
    const loaderDaily = useSelector((state: {dStatistics: typeStatisticsState}) => state.dStatistics.loaderDaily)
    const loaderFilter = useSelector((state: {dStatistics: typeStatisticsState}) => state.dStatistics.loaderFilter)


    return(
        <>
            {mainStatisticData && mainStatisticData.labels.length !== 0
                ? <BarChart amountTitle={amountTitle} data={mainStatisticData}/>
                : <div className="flex justify-center">
                    <Alert type="info" title={<Trans>No data. Change the period.</Trans>}/>
                </div>
            }

            {loaderDaily || loaderFilter ? <Loader/> : null}
        </>

    )
}